import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=b6af8388&scoped=true"
import script from "./Imagenes.vue?vue&type=script&lang=js"
export * from "./Imagenes.vue?vue&type=script&lang=js"
import style0 from "./Imagenes.vue?vue&type=style&index=0&id=b6af8388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af8388",
  null
  
)

export default component.exports